module.exports = __webpack_public_path__ + "static/images/monet/left_panel_group_title.png";